import React, {useContext} from "react";
import {View, Text} from "@react-pdf/renderer";
import PropTypes from "prop-types";

import {PrintDocumentContext} from "./printDocumentContext";
import {cartItemInterface} from "../../shoppingCart/cartItemInterface";
import PrintDocumentBodyCartItem from "./printDocumentBodyCartItem";


const PrintDocumentBodyBundledCartItems = (props) => {
  const {styles, cartItem, fabricatorData, locale, cartItems} = props;
  // const fabricatorSettings = fabricatorData.settings;

  const bundleProducts = cartItems ? cartItems.filter(cItem => {
    return cItem.bundleParentId && (cItem.bundleParentId === cartItem.id)
  }) : [];

  const printContext = useContext(PrintDocumentContext);

  return (
    <View style={styles.cartItemBundled} wrap={true}>
      <Text style={[styles.cartItemSimilarTitle, styles.cartItemSimilarTitleBundled]}>
        {printContext.messages["shoppingCart.bundledItems"]}
      </Text>
      <View style={styles.cartItemSimilarTitlePadding}>
        {bundleProducts.map(bundleCartItem => {
          return <PrintDocumentBodyCartItem locale={locale}
                                            key={bundleCartItem.id}
                                            fabricatorData={fabricatorData}
                                            cartItem={bundleCartItem}
                                            cartItems={cartItems}
                                            styles={styles}/>
        })}
      </View>
    </View>
  )
};

PrintDocumentBodyBundledCartItems.propTypes = {
  cartItem: PropTypes.shape(cartItemInterface),
  fabricatorData: PropTypes.object.isRequired,
  locale: PropTypes.string.isRequired,
  styles: PropTypes.object.isRequired,
};

export default PrintDocumentBodyBundledCartItems
